import ServerError from '@/common/utils/errors/ServerError';

export const serverErrorMessage = 'Internal Server Error. Please contact your system administrator.';

export default class InternalServerError extends ServerError {
  constructor(response: CreateFetchResponse, body: ErrorBody) {
    super(response, body, undefined, undefined);

    if (process.env.NODE_ENV === 'production') {
      this.message = serverErrorMessage;
    } else {
      this.message = ((this.body as ErrorBody)?.error?.error?.message)
        || ((this.body as ErrorBody)?.message)
        || (response?.statusText)
        || 'Error';
    }
  }
}
